import { ClusterInterface } from "../../types/interfaces";

export const getClusterImageUrl = (
  cluster: Pick<ClusterInterface, "domain" | "port" | "token">,
  path: string,
): string => {
  if (!cluster.port || !cluster.token) return "";
  const cleanPath = path.replace(/^\//, "");
  return `https://${cluster.domain}/sales-api/${cluster.port}/${cluster.token}/api/v1/data/file?path=${cleanPath}`;
};

export const getFirstImage = (files?: string[]) => {
  if (!files) return undefined
  const videoExts = ['.mp4', '.webm', '.mov', '.avi', '.mkv', '.m4v']
  return files.find((f) => !videoExts.some((ext) => f.toLowerCase().endsWith(ext)))
}